<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="section-panel-header">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="36" class="mr-3 panel-avatar">
          <v-icon dark small>gavel</v-icon>
        </v-avatar>
        <div>
          <div class="section-title">Documents & Conformité</div>
          <div class="section-subtitle">Plan de nettoyage, PMS et documents légaux</div>
        </div>
      </div>
      <template v-slot:actions>
        <v-icon color="primary">$expand</v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row class="mt-2 px-2">
        <v-col cols="12" md="6">
          <div class="config-block-title mb-3">
            <v-icon small color="primary" class="mr-1">cleaning_services</v-icon>Plan de nettoyage
          </div>
          <FileUpload
            :value="nettoyage"
            @input="$emit('update:nettoyage', $event)"
            :formats="['.xls', '.xlsx', '.doc', '.docx', '.pdf']"
            :multiple="false"
            :service="'nettoyage'"
            :model="model"
            :code="code"
            :loading="loading"
          />
        </v-col>
        <v-col cols="12" md="6">
          <div class="config-block-title mb-3">
            <v-icon small color="primary" class="mr-1">folder_open</v-icon>Autres documents (PMS)
          </div>
          <FileUpload
            :value="pms"
            @input="$emit('update:pms', $event)"
            :formats="['.xls', '.xlsx', '.doc', '.docx', '.pdf', '.jpeg', '.jpg', '.png']"
            :multiple="true"
            :service="'pms'"
            :model="model"
            :code="code"
            :loading="loading"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue'

export default {
  name: 'LegislationSection',
  components: { FileUpload },
  props: {
    nettoyage: { type: Object, default: () => ({ files: [] }) },
    pms: { type: Object, default: () => ({ files: [] }) },
    model: { type: [Object, Array], default: () => ({}) },
    code: { type: [Number, String], default: null },
    loading: { type: Boolean, default: false },
  },
}
</script>
